import { useEffect, useState } from 'react';

const navLinks = [
  { label: '甜番精选', href: '#recommend' },
  { label: '心动榜单', href: '#ranking' },
  { label: '挑选标准', href: '#standards' },
  { label: '追番口碑', href: '#feedback' },
  { label: '常见问题', href: '#faq' },
  { label: '关于我们', href: '#about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || open;

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 transition-all duration-300 ${
        solid
          ? 'bg-background-50/90 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 h-16 md:h-20 flex items-center justify-between">
        <a href="#home" className="flex items-center gap-2 group">
          <span className="w-9 h-9 flex items-center justify-center rounded-full bg-primary-500 text-background-50 group-hover:bg-primary-600 transition-colors">
            <i className="ri-heart-3-fill text-lg"></i>
          </span>
          <span
            className={`font-heading text-xl md:text-2xl tracking-wide transition-colors ${
              solid ? 'text-foreground-900' : 'text-white'
            }`}
          >
            羞羞的动漫
          </span>
        </a>

        <ul className={`hidden md:flex items-center gap-1 ${solid ? 'text-foreground-700' : 'text-white/90'}`}>
          {navLinks.map((link) => (
            <li key={link.href}>
              <a
                href={link.href}
                className="inline-flex px-3 py-2 text-sm rounded-md whitespace-nowrap hover:bg-background-200/60 hover:text-primary-600 transition-colors"
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-2">
          <a
            href="#subscribe"
            className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 text-sm font-medium text-background-50 bg-primary-500 hover:bg-primary-600 rounded-md whitespace-nowrap transition-colors"
          >
            <i className="ri-mail-send-line"></i>
            订阅更新
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className={`md:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              solid ? 'text-foreground-800 hover:bg-background-200/60' : 'text-white hover:bg-white/10'
            }`}
          >
            <i className={open ? 'ri-close-line text-2xl' : 'ri-menu-line text-2xl'}></i>
          </button>
        </div>
      </nav>

      {open && (
        <div className="md:hidden bg-background-50/95 backdrop-blur-md border-t border-background-200/70 px-4 py-3">
          <ul className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  onClick={() => setOpen(false)}
                  className="block px-3 py-2.5 text-sm text-foreground-700 rounded-md hover:bg-background-200/60 hover:text-primary-600 transition-colors"
                >
                  {link.label}
                </a>
              </li>
            ))}
            <li className="mt-1">
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                className="flex items-center justify-center gap-1.5 px-3 py-2.5 text-sm font-medium text-background-50 bg-primary-500 rounded-md"
              >
                <i className="ri-mail-send-line"></i>
                订阅更新
              </a>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}